<template>
  <div class="integral">
      <div class="balance_tit">
        余额
      </div>
      <div class="balance_box">
           <div class="balance_pay">
             <div class="balance_left">
               <div class="balance_pay_tit">
                 当前可用味豆
               </div>
               <div class="balance_price">
                 {{medata.integral}}
               </div>
             </div>
             <img src="../../../assets/balance_img.png" alt="" srcset="">
           </div>
           <div class="integral_tit">
              领味豆
           </div>
           <div class="integral_box">
             <img src="../../../assets/integral_img.png" alt="">
             <div class="integral_cneter">
               <div class="integral_title">
                 消息
               </div>
               <div class="integral_info">
              消费1.00元可获得1味豆
               </div>
             </div>
             <div class="integral_btn">
               去下单
             </div>
           </div>
      </div>
  </div>
</template>

<script>
  import {getpersonageapi} from "../../../api/http.js"
  export default{
    name:"integral",
    data(){
      return{
        medata:[]
      }
    },
   async created() {
      const res = await getpersonageapi()
      console.log(res.data.data);
      if(res.data.code == 200){
        this.medata =res.data.data
      }
    }
  }
</script>

<style lang="less">
  .integral{
    width: 100%;
    .balance_tit{
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #292929;
      margin-bottom: 20px;
    }
    .balance_box{
      padding: 33px 22px;
      width: 100%;
      height: 500px;
      border: 1px solid #CCCDCE;
      .balance_pay{
        width: 382px;
        height: 137px;
        color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(90deg, #EC5D89 0%, #EA5551 100%);
        border-radius: 10px;
        .balance_left{
          height: 100%;
          padding: 35px;
          box-sizing: border-box;
          .balance_pay_tit{
            margin-bottom: 20px;
          }
          .balance_price{}
        }
        img{
          margin-right: 20px;
        }
      }
      .integral_tit{
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #292929;
        margin-top: 40px;
        margin-bottom: 20px;
      }
      .integral_box{
        width: 401px;
        height: 105px;
        background: rgba(153, 153, 153, 0.05);
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 17px 0 7px;
        box-sizing: border-box;
        font-size: 14px;
        img{
          width: 48px;
          height: 48px;
        }
        .integral_cneter{
          .integral_title{
            margin-bottom: 10px;
          }
          .integral_info{

          }
        }
        .integral_btn{
          width: 83px;
          height: 32px;
          background: #FEF0F0;
          border: 1px solid #FEB633;
          border-radius: 40px;
          text-align: center;
          line-height: 32px;
          color: #F4A921;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/view/integral.vue